import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppService } from './app.service';
import { ToastsContainerComponent } from './_core/toasts-container.component';
import { ConsentBannerComponent } from './consent/consent-banner.component';

@Component({
    standalone: true,
    selector: 'app-root',
    imports: [RouterOutlet, ToastsContainerComponent, ConsentBannerComponent],
    // Story 50.6 — the consent banner comes first so keyboard and screen-reader users meet it before
    // the page; it is a fixed card at the bottom, and renders nothing on the server.
    template: ` <app-consent-banner /><router-outlet></router-outlet><app-toasts /> `
})
export class AppComponent implements OnInit {
  appService = inject(AppService);

  ngOnInit() {
    this.appService.addBrowserClassToBody();
  }
}
